export function initialiseSeoReportThumbCharts(root = document) {
    const chartConstructor = window.Chart;

    if (!chartConstructor) {
        return;
    }

    const cards = root.querySelectorAll(".js-report-thumb");

    cards.forEach((card) => {
        if (card.dataset.chartInitialized === "1") {
            return;
        }

        const canvas = card.querySelector(".js-report-thumb-canvas");

        if (!canvas) {
            return;
        }

        let labels = [];
        let values = [];

        try {
            labels = JSON.parse(card.dataset.chartLabels || "[]");
            values = JSON.parse(card.dataset.chartValues || "[]");
        } catch (error) {
            console.error("Unable to parse thumb chart data.", error);
            return;
        }

        if (!labels.length || !values.length) {
            return;
        }

        card.dataset.chartInitialized = "1";

        new chartConstructor(canvas.getContext("2d"), {
            type: "line",
            data: {
                labels,
                datasets: [
                    {
                        label: "Interest",
                        data: values,
                        pointRadius: 3,
                        pointHoverRadius: 4,
                    },
                ],
            },
            options: {
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                },
                scales: {
                    x: {
                        display: false,
                        grid: {
                            display: false,
                        },
                    },
                    y: {
                        display: false,
                        grid: {
                            display: false,
                        },
                        beginAtZero: true,
                    },
                },
            },
        });
    });
}

